import { render, staticRenderFns } from "./Transcript.vue?vue&type=template&id=09d25708&scoped=true&"
import script from "@/scripts/Activity/Transcript/index.js?vue&type=script&lang=js&"
export * from "@/scripts/Activity/Transcript/index.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d25708",
  null
  
)

export default component.exports